// Module
var code = `<div class="jumbotron-surface social-media-surface">

  <div class="jumbotron-panel-head">
    <div class="social-media-head-main" ng-click="ctrl.isCollapsed = !ctrl.isCollapsed">
      <i class="fas fa-fw social-media-chevron" aria-hidden="true"
        ng-class="{'fa-chevron-right': ctrl.isCollapsed, 'fa-chevron-down': !ctrl.isCollapsed}"></i>
      <span class="jumbotron-heading">Social Media</span>
      <span class="jumbotron-note social-media-count">{{ctrl.SocialMediaSources.length}} sources</span>
    </div>
  </div>

  <div class="social-media-body" ng-show="!ctrl.isCollapsed">

    <empty-info ng-show="ctrl.SocialMediaSources.length === 0" no="Social Media"></empty-info>

    <div class="jumbotron-media-grid" ng-show="ctrl.SocialMediaSources.length > 0">
      <div class="jumbotron-media-tile" ng-repeat="item in ctrl.SocialMediaSources | orderBy:'filter'">
        <bulk-select class="jumbotron-media-tile-header" title="{{item.filter}}" media-title="item.filter"
          on-toggle="ctrl.toggleBulk(item.id)"></bulk-select>
        <div class="jumbotron-media-tile-content">
          <div class="jumbotron-media-tile-thumb social-media-thumb center-center text-muted">
            <i ng-if="item.type === 'InstagramFreetext'" class="fas fa-font fa-5x" aria-hidden="true"></i>
            <i ng-if="item.type === 'InstagramHashtag'" class="fas fa-hashtag fa-5x" aria-hidden="true"></i>
            <i ng-if="item.type === 'InstagramUsername'" class="fab fa-instagram fa-5x" aria-hidden="true"></i>
            <i ng-if="item.type === 'InstagramMention'" class="fas fa-at fa-5x" aria-hidden="true"></i>
          </div>
          <div class="jumbotron-media-tile-controls">
            <div class="jumbotron-media-tile-control d-grid" ng-if="ctrl.scene">
              <button type="button" class="btn btn-sm btn-outline-primary" ng-click="ctrl.addToScene(item.id)"
                ng-disabled="!ctrl.isSceneActive()">
                <i class="fas fa-plus-circle" aria-hidden="true"></i> Add to playlist
              </button>
            </div>
            <!-- TODO: The server stores the time of the fetch in UTC. The
                 offset to the local time is not verified. -->
            <div class="jumbotron-media-tile-control social-media-meta">
              Post last fetched at {{item.lastUpdate | amUtc | amLocal | amDateFormat:'YYYY-MM-DD HH:mm:ss'}}
            </div>
            <div class="jumbotron-media-tile-control social-media-meta">
              <span>Type:</span>
              <span ng-if="item.type === 'InstagramFreetext'">Instagram Freetext</span>
              <span ng-if="item.type === 'InstagramHashtag'">Instagram Hashtag</span>
              <span ng-if="item.type === 'InstagramUsername'">Instagram Username</span>
              <span ng-if="item.type === 'InstagramMention'">Instagram Mention</span>
            </div>
            <div class="jumbotron-media-tile-control">
              <media-labels social-media-id="item.id"></media-labels>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
// Exports
export default code;